(function () {
  if (window.vpHistoryTimelineReady) return;
  window.vpHistoryTimelineReady = true;

  var STEPS = { ArrowLeft: -1, ArrowUp: -1, ArrowRight: 1, ArrowDown: 1 };

  function findTab(target) {
    return target && target.closest ? target.closest('.vp-ht__tab') : null;
  }

  function activate(tab) {
    var root = tab.closest('[data-vp-ht]');
    if (!root) return;
    var index = tab.getAttribute('data-vp-ht-index');

    root.querySelectorAll('[role="tab"]').forEach(function (item) {
      var selected = item === tab;
      item.setAttribute('aria-selected', selected);
      item.tabIndex = selected ? 0 : -1;
      item.classList.toggle('is-active', selected);
    });

    root.querySelectorAll('[role="tabpanel"]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-vp-ht-index') !== index;
    });
  }

  document.addEventListener('click', function (event) {
    var tab = findTab(event.target);
    if (tab) activate(tab);
  });

  document.addEventListener('keydown', function (event) {
    var tab = findTab(event.target);
    if (!tab) return;

    var tabs = Array.prototype.slice.call(tab.parentNode.children);
    var current = tabs.indexOf(tab);
    var next;

    if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = tabs.length - 1;
    else if (STEPS[event.key]) next = (current + STEPS[event.key] + tabs.length) % tabs.length;
    else return;

    event.preventDefault();
    activate(tabs[next]);
    tabs[next].focus();
  });

  document.addEventListener('shopify:block:select', function (event) {
    var tab = findTab(event.target);
    if (tab) activate(tab);
  });
})();
